import { type GkAirProxyServiceWebResponseRecommendationsValue } from '@redteclab/api/clients/crosssellers-proxy-service'

export const gkAirAccessorGetAreaTitle = ({
  areaData,
}: {
  areaData: GkAirProxyServiceWebResponseRecommendationsValue | undefined
}): string => {
  return areaData?.title ?? ''
}
